const { makeStyles } = require('@material-ui/core');

const drawerWidth = 256;

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    boxShadow: 'none',
    backgroundColor: '#EDEDED',
    borderBottom: '1px solid #E0E3E8',
    /** Acima do Drawer (1200) para o título não ficar “por baixo” da faixa da sidebar */
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['left', 'right', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  /** fixed + left: drawerWidth evita overlap com marginLeft em alguns browsers */
  appBarOpen: {
    left: drawerWidth,
    right: 0,
    width: 'auto',
    marginLeft: 0,
    transition: theme.transitions.create(['left', 'right', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  appBarCollapsed: {
    left: theme.spacing(8),
    right: 0,
    width: 'auto',
    marginLeft: 0,
    transition: theme.transitions.create(['left', 'right', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.up('sm')]: {
      left: theme.spacing(9),
    },
  },
  drawer: {
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },

  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 1),
    marginTop: 40,
  },
  iconSideContainer: {
    position: 'absolute',
    display: 'flex',
    overflow: 'inherit',
  },
  toggleRow: {
    display: 'flex',
    width: '100%',
    position: 'relative',
    minHeight: 32,
    alignItems: 'center',
  },
  toggleRowOpen: {
    justifyContent: 'flex-end',
  },
  toggleRowCollapsed: {
    justifyContent: 'center',
  },
  profileCollapsed: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '12px 0',
    width: '100%',
  },
  container_button_open: {
    display: 'flex',
    justifyContent: 'center',
    width: 30,
  },
  container_image: { display: 'flex', width: '100%', justifyContent: 'center' },
  sideImage: {
    textAlign: 'center',
  },
  imageSideBar: {
    width: 106.3,
    height: 106.3,
  },
  profile: {
    display: 'flex',
    alignItems: 'center',
    margin: '15px 5px',
  },

  title: {
    marginLeft: 21,
  },
  drawerPaper: {
    whiteSpace: 'wrap',
    overflow: 'inherit',
    width: 256,
    backgroundColor: '#E6E1DB',
    borderRight: '1px solid #C0B8AB',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    backgroundColor: '#E6E1DB',
    borderRight: '1px solid #C0B8AB',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'inherit',
    flexDirection: 'column',
  },
}));
